module.exports = __webpack_public_path__ + "static/media/01.81338ed3.jpg";